import * as React from "react";
const SvgCartInsert20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M10.834.833H9.167v5.138L7.349 4.153 6.171 5.332l3.824 3.824 1.179-1.178-.01-.01 2.656-2.636-1.174-1.183-1.813 1.799V.833ZM6.511 19.167a1.775 1.775 0 1 0 0-3.55 1.775 1.775 0 0 0 0 3.55Zm9.801-1.776a1.775 1.775 0 1 1-3.55 0 1.775 1.775 0 0 1 3.55 0Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M.476 3.338h1.61L4.506 15v.002H16.55l.345-1.666H5.862l-.346-1.669h11.725l1.555-7.5h-1.702L15.884 10H5.17L3.442 1.669l-.01.003H.475v1.666Z"
    })
  );
export default SvgCartInsert20Px;
